export const DefaultImage = {
  id: '',
  src: '',
  alt: '',
  crop: null,
  hotspot: null,
  metadata: null,
};

export const DefaultOverviewSideNav = {
  id: 'defaultOverview',
  label: 'overview',
  slug: 'overview',
};

export const DefaultReferencesSideNav = {
  id: 'defaultReferences',
  label: 'References',
  slug: 'references',
};

export const DefaultSeoSettings = {
  title: 'Buoy Health: Check Symptoms & Find the Right Care',
  description:
    'Check your symptoms and clarify your options for care. The Buoy A.I. health assistant guides you on your way to well, the moment you feel sick.',
  // TO-DO: Replace with new default image and image alt
  image: 'https://buoyhealth.imgix.net/company-main.png?auto=format,compress',
  alt:
    "Image of Buoy's Health Symptom Checker on a phone, with a tagline that says 'Start your care on the right foot'",
};
